import { render, staticRenderFns } from "./DosageInfo.vue?vue&type=template&id=46615d4c&scoped=true"
import script from "./DosageInfo.vue?vue&type=script&lang=js"
export * from "./DosageInfo.vue?vue&type=script&lang=js"
import style0 from "./DosageInfo.vue?vue&type=style&index=0&id=46615d4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46615d4c",
  null
  
)

export default component.exports